import type { TSimulationMode } from '@doutorsim/shared/applications'

export const SIMULATION_MODE_OPTIONS: { value: TSimulationMode; label: string }[] = [
  { value: 'product_cost', label: 'Tradicional' },
  { value: 'total_cost', label: 'Sem juros' },
]
